import { ImageLoader } from "~/components/ImageLoader";
import { Link } from "~/components/Link";
import { CategoryBadge } from "~/modules/blog/components/CategoryBadge";
import { AuthorByline } from "~/modules/blog/components/PostMeta";
import { BlogPost, getPostImage, urlFor } from "~/modules/blog/api/sanity";
import { BlogUserEvents } from "~/modules/analytics/events/blog";

// // // //

export function FeaturedPost(props: { post: BlogPost }) {
    const { post } = props;
    const image = getPostImage(post);

    return (
        <Link
            href={`/blog/${post.slug.current}`}
            className="group block text-foreground"
            analyticsLabel={BlogUserEvents.ClickFeaturedPost}
            analyticsEventProperties={{ slug: post.slug.current }}
        >
            {image && (
                <div className="overflow-hidden rounded-lg border bg-muted">
                    <ImageLoader
                        src={urlFor(image).width(1600).url()}
                        alt={post.title}
                        className="h-auto w-full"
                    />
                </div>
            )}
            <div className="mt-5">
                <CategoryBadge post={post} />
                <h2 className="mt-3 text-3xl font-semibold leading-tight text-foreground transition-colors group-hover:text-link">
                    {post.title}
                </h2>
                <AuthorByline post={post} className="mt-5 border-t pt-4" />
            </div>
        </Link>
    );
}
